import React from 'react';
import styles from './AboutTab.module.scss';
import { Stack } from '@mui/material';

export const AboutTab = ({ group }) => (
  <div className={styles.content}>
    <div className={styles.nameTitle}>
      <img src="/images/ph_globe-light.svg" alt="" style={{ width: 20, height: 20 }} />
      <div className={styles.groupStatus}>Public group</div>
    </div>
    <div className={styles.infoItemBlock}>
      <div className={styles.title}>Description:</div>
      <div className={styles.description}>
        {group.description ? group.description : "There's no information here yet"}
      </div>
    </div>
    <div className={styles.infoItemBlock}>
      <div className={styles.title}>Rules:</div>
      <div className={styles.description}>
        {group.rules && group.rules.length > 0 ? (
          <div className={styles.rulesBlock}>
            {group.rules.map((item) => (
              <div key={item.id} className={styles.ruleItem}>
                <div>{`${item.id}.  `}</div>
                <div className={styles.ruleText}>{item.description}</div>
              </div>
            ))}
          </div>
        ) : (
          "There's no information here yet"
        )}
      </div>
    </div>
    {group.tags && group.tags.length > 0 && (
      <div className={styles.infoItemBlock}>
        <Stack direction="row" alignItems="center" flexWrap="wrap" gap="8px">
          {group.tags.map((item) => (
            <Stack
              key={item.id}
              className={styles.tagChip}
              direction="row"
              spacing={1}
              alignItems="center"
            >
              <div>{item.name}</div>
            </Stack>
          ))}
        </Stack>
      </div>
    )}
  </div>
);
